/**
 * Given an array of models where the id is either in the data or can be otherwise synchronously derived, create a batch map. Can also accept a similar type to the model, for example
 * if you temporarily attach the id to the model and then want to remove it upon batching. Use the transformFunction argument to apply this transformation.
 * @param array
 * @param idFunction
 * @returns
 */
export function arrayToModelBatch(array, idFunction, transformFunction) {
    const batch = {};
    array.forEach(model => {
        let newValue;
        if (transformFunction) {
            newValue = transformFunction(model);
        }
        else {
            newValue = model;
        }
        batch[idFunction(model)] = newValue;
    });
    return batch;
}
/**
 * Iterates over each model in the batch and runs the callback function
 * @param batch
 * @param callback
 */
export function forEachModelInBatch(batch, callback) {
    Object.keys(batch).forEach(id => {
        callback(batch[id]);
    });
}
//# sourceMappingURL=collection-model-batch.js.map